import { useState } from "react";
import Icon from "../../components/shared/Icon";
import { MENU } from "../../data/initialData";

// ── Admin Pages ──────────────────────────────────────────────
import Dashboard from "./Dashboard";
import RegisterSociety from "./RegisterSociety";
import ChangePassword from "./ChangePassword";
import ManageSociety from "./ManageSociety";
import DataLocking from "./DataLocking";
import ManageMembers from "./ManageMembers";
import UploadMembersData from "./UploadMembersData";
import UploadVehicleData from "./UploadVehicleData";
import EditMemberDetails from "./EditMemberDetails";
import ManageParking from "./ManageParking";
import DocumentsManager from "./DocumentsManager";
import NoticeManager from "./NoticeManager";
import EventManager from "./EventManager";
import CreateTickets from "./CreateTickets";
import ViewTickets from "./ViewTickets";
import UserRights from "./UserRights";
import SubCommittee from "./SubCommittee";
import StaffManagement from "./StaffManagement";
import ManagerRegistration from "./ManagerRegistration";
import SetManager from "./SetManager";
import ManagerRights from "./ManagerRights";
import VendorManagement from "./VendorManagement";
import BillGeneration from "./BillGeneration";
import Receipts from "./Receipts";
import Payments from "./Payments";

// ── Accounts Pages ───────────────────────────────────────────
import AccountGroupPage from "../accounts/AccountGroupPage";
import AccountSubGroupPage from "../accounts/AccountSubGroupPage";
import BankCashMasterPage from "../accounts/BankCashMasterPage";
import AccountMasterPage from "../accounts/AccountMasterPage";
import BudgetPage from "../accounts/BudgetPage";
import SetChargesPage from "../accounts/SetChargesPage";
import BillParametersPage from "../accounts/BillParametersPage";
import {
  RegularBillPage, RegularBillIndividualPage,
  SupplementaryBillPage, SupplementaryBillIndividualPage,
} from "../accounts/BillGenerationPages";
import {
  AddVendorsPage, VendorContractPage, VendorBillingPage, VendorReportPage,
} from "../accounts/VendorPages";
import TransactionPage from "../accounts/TransactionPage";
import {
  BankReconciliationPage, BankSlipPage, ImportTransactionsPage,
  TransferClosingBalancesPage, FixedDepositsPage,
} from "../accounts/OtherAccountPages";

// ── Report Pages (from society-react-mvc) ───────────────────
import BankbookReport       from "../reports/bank/BankbookReport";
import CashbookReport       from "../reports/bank/CashbookReport";
import ReconciliationReport from "../reports/bank/ReconciliationReport";
import ReceiptPayment       from "../reports/bank/ReceiptPayment";
import OpeningBalances      from "../reports/members/OpeningBalances";
import BillwiseDues         from "../reports/members/BillwiseDues";
import TariffLedger         from "../reports/income/TariffLedger";
import GSTBilling           from "../reports/gst/GSTBilling";
import GSTVendors           from "../reports/gst/GSTVendors";
import IncomeExpenditure    from "../reports/finalaccounts/IncomeExpenditure";
import CommitteeMembers     from "../reports/society/CommitteeMembers";
import SocietyMembers       from "../reports/society/SocietyMembers";
import Tenants              from "../reports/society/Tenants";
import ParkingReport        from "../reports/society/ParkingReport";
import FDRegister           from "../reports/registers/FDRegister";
import SharesRegister       from "../reports/registers/SharesRegister";
import LienRegister         from "../reports/registers/LienRegister";
import NomineeRegister      from "../reports/registers/NomineeRegister";
import GenericPage          from "../reports/GenericPage";

import "../../styles/globals.css";
import "../../styles/global.css";
import "../../styles/sidebar.css";
import "../../styles/header.css";

// ── Sidebar ──────────────────────────────────────────────────
function Sidebar({ activeMenu, setActiveMenu, collapsed, setCollapsed }) {
  const [openMenus, setOpenMenus] = useState({ admin: true });
  const toggle = id => setOpenMenus(p => ({ ...p, [id]: !p[id] }));

  const renderItems = (items, depth = 0) => items.map(item => (
    <div key={item.id}>
      <button
        onClick={() => { if (item.children?.length) toggle(item.id); else setActiveMenu(item.id); }}
        title={collapsed && depth === 0 ? item.label : ""}
        style={{ width:"100%", display:"flex", alignItems:"center", gap:8, padding: collapsed ? "9px 11px" : depth === 0 ? "9px 12px" : `8px 12px 8px ${16 + depth * 12}px`, background: activeMenu === item.id ? "rgba(66,165,245,0.18)" : "transparent", border:"none", borderRadius:7, cursor:"pointer", color: activeMenu === item.id ? "#42a5f5" : depth === 0 ? "#b0bec5" : "#90a4ae", fontSize: depth === 0 ? 13 : 12.5, fontWeight: depth === 0 ? 500 : 400, marginBottom:1, textAlign:"left", transition:"all 0.15s", borderLeft: activeMenu === item.id && depth > 0 ? "2px solid #42a5f5" : depth > 0 ? "2px solid transparent" : "none" }}
        onMouseEnter={e => { if (activeMenu !== item.id) e.currentTarget.style.background = "rgba(255,255,255,0.06)"; }}
        onMouseLeave={e => { if (activeMenu !== item.id) e.currentTarget.style.background = "transparent"; }}>
        {item.icon && <Icon name={item.icon} size={16} color={activeMenu === item.id ? "#42a5f5" : "#78909c"} />}
        {!collapsed && <><span style={{ flex:1 }}>{item.label}</span>{item.children?.length > 0 && <Icon name={openMenus[item.id] ? "chevronDown" : "chevronRight"} size={13} color="#546e7a" />}</>}
      </button>
      {!collapsed && item.children?.length > 0 && openMenus[item.id] && <div>{renderItems(item.children, depth + 1)}</div>}
    </div>
  ));

  return (
    <div style={{ width: collapsed ? 58 : 245, minHeight:"100vh", background:"#1a2744", display:"flex", flexDirection:"column", transition:"width 0.25s ease", position:"fixed", left:0, top:0, bottom:0, zIndex:100, overflowY:"auto", overflowX:"hidden" }}>
      <div style={{ padding: collapsed ? "16px 12px" : "16px 18px", borderBottom:"1px solid rgba(255,255,255,0.08)", display:"flex", alignItems:"center", gap:10, flexShrink:0 }}>
        <div style={{ width:34, height:34, borderRadius:8, background:"linear-gradient(135deg,#42a5f5,#1565c0)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}><Icon name="building" size={18} color="#fff" /></div>
        {!collapsed && <div><div style={{ color:"#fff", fontWeight:700, fontSize:13, lineHeight:1.2 }}>Ap IT Services</div><div style={{ color:"#7986cb", fontSize:11 }}>Admin Panel</div></div>}
      </div>
      <nav style={{ flex:1, padding:"10px 6px" }}>{renderItems(MENU)}</nav>
      <button onClick={() => setCollapsed(!collapsed)} style={{ margin:"8px", padding:"9px", background:"rgba(255,255,255,0.06)", border:"none", borderRadius:8, cursor:"pointer", color:"#78909c", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
        <Icon name={collapsed ? "chevronRight" : "chevronLeft"} size={15} />
      </button>
    </div>
  );
}

// ── Topbar ───────────────────────────────────────────────────
function Topbar({ onLogout, sidebarCollapsed, adminUser }) {
  return (
    <div style={{ position:"fixed", top:0, left: sidebarCollapsed ? 58 : 245, right:0, zIndex:90, height:54, background:"#fff", borderBottom:"1px solid #e8eaf0", display:"flex", alignItems:"center", justifyContent:"space-between", padding:"0 22px", transition:"left 0.25s ease", boxShadow:"0 2px 8px rgba(0,0,0,0.06)" }}>
      <div style={{ display:"flex", alignItems:"center", gap:10 }}>
        <span style={{ fontWeight:700, fontSize:15, color:"#1a2744" }}>Ap IT Services</span>
        <span style={{ background:"#e3f2fd", color:"#1565c0", fontSize:11, padding:"3px 8px", borderRadius:20, fontWeight:600 }}>FY 2025-2026</span>
        {adminUser?.society && <span style={{ background:"#f3e5f5", color:"#7b1fa2", fontSize:11, padding:"3px 8px", borderRadius:20, fontWeight:600 }}>📍 {adminUser.society}</span>}
      </div>
      <div style={{ display:"flex", alignItems:"center", gap:14 }}>
        {adminUser && (
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ width:28, height:28, borderRadius:"50%", background:`hsl(${(adminUser.id||1) * 80},60%,45%)`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, color:"#fff", fontWeight:700 }}>{(adminUser.name||"A").charAt(0)}</div>
            <span style={{ fontSize:12, color:"#455a64", fontWeight:500 }}>{adminUser.name}</span>
          </div>
        )}
        <div style={{ position:"relative", cursor:"pointer" }}>
          <Icon name="bell" size={19} color="#607d8b" />
          <span style={{ position:"absolute", top:-4, right:-4, background:"#f44336", color:"#fff", borderRadius:10, fontSize:9, padding:"1px 4px", fontWeight:700 }}>2</span>
        </div>
        <button onClick={onLogout} style={{ background:"#fce8e6", border:"none", borderRadius:8, padding:"6px 12px", cursor:"pointer", display:"flex", alignItems:"center", gap:5, fontSize:12, color:"#c62828", fontWeight:500 }}>
          <Icon name="logout" size={14} color="#c62828" /> Logout
        </button>
      </div>
    </div>
  );
}

// ── Page Router ──────────────────────────────────────────────
function renderContent(activeMenu, setActiveMenu, adminUser) {
  switch (activeMenu) {
    // Admin
    case "home":                          return <Dashboard setActiveMenu={setActiveMenu} adminUser={adminUser} />;
    case "register-society":              return <RegisterSociety />;
    case "change-password":               return <ChangePassword adminUser={adminUser} />;
    case "manage-society":                return <ManageSociety adminUser={adminUser} />;
    case "data-locking":                  return <DataLocking />;
    case "manage-member":                 return <ManageMembers setActiveMenu={setActiveMenu} />;
    case "upload-members-data":           return <UploadMembersData />;
    case "upload-vehicle-data":           return <UploadVehicleData />;
    case "edit-member-details":           return <EditMemberDetails />;
    case "manage-parking":                return <ManageParking />;
    case "documents-manager":             return <DocumentsManager />;
    case "notice-manager":                return <NoticeManager />;
    case "event-manager":                 return <EventManager />;
    case "create-tickets":                return <CreateTickets />;
    case "view-tickets":                  return <ViewTickets />;
    case "manage-complaints":             return <ViewTickets />;
    case "user-rights":                   return <UserRights />;
    case "sub-committee":                 return <SubCommittee />;
    case "staff-management":              return <StaffManagement />;
    case "manager-registration":          return <ManagerRegistration />;
    case "set-manager":                   return <SetManager />;
    case "manager-rights":                return <ManagerRights />;
    case "vendor-management":             return <VendorManagement />;
    case "bill-generation":               return <BillGeneration />;
    case "receipts":                      return <Receipts />;
    case "payments":                      return <Payments />;

    // Accounts
    case "set-account":
    case "set-account-group":             return <AccountGroupPage />;
    case "set-account-subgroup":          return <AccountSubGroupPage />;
    case "bank-cash-master":              return <BankCashMasterPage />;
    case "account-master":                return <AccountMasterPage />;
    case "budget":                        return <BudgetPage />;
    case "set-charges":                   return <SetChargesPage />;
    case "bill-parameters":               return <BillParametersPage />;
    case "bill-generation-regular":       return <RegularBillPage />;
    case "bill-generation-regular-individual": return <RegularBillIndividualPage />;
    case "bill-generation-supplementary":         return <SupplementaryBillPage />;
    case "bill-generation-supplementary-individual": return <SupplementaryBillIndividualPage />;
    case "vendors-add":                   return <AddVendorsPage />;
    case "vendors-contract":              return <VendorContractPage />;
    case "vendors-billing":               return <VendorBillingPage />;
    case "vendors-report":                return <VendorReportPage />;
    case "transaction-menu":              return <TransactionPage />;
    case "bank-reconciliation":           return <BankReconciliationPage />;
    case "bank-slip":                     return <BankSlipPage />;
    case "import-transactions":           return <ImportTransactionsPage />;
    case "transfer-closing-balances":     return <TransferClosingBalancesPage />;
    case "fixed-deposits":                return <FixedDepositsPage />;

    // Bank & Cash Reports
    case "bankbook":                      return <BankbookReport />;
    case "cashbook":                      return <CashbookReport />;
    case "reconciliation":                return <ReconciliationReport />;
    case "receipt-payment":               return <ReceiptPayment />;

    // Members Reports
    case "opening-balances":
    case "regular-opening":               return <OpeningBalances />;
    case "billwise-dues":                 return <BillwiseDues />;

    // Income / Expense
    case "tariff-ledger":                 return <TariffLedger />;

    // GST
    case "gst-billing":                   return <GSTBilling />;
    case "gst-vendors":                   return <GSTVendors />;

    // Final Accounts
    case "income-expenditure":            return <IncomeExpenditure />;

    // Society Reports
    case "committee-members":             return <CommitteeMembers />;
    case "society-members":              return <SocietyMembers />;
    case "tenants":                       return <Tenants />;
    case "parking-report":               return <ParkingReport />;

    // Registers
    case "fd-register":                   return <FDRegister />;
    case "shares-register":               return <SharesRegister />;
    case "lien-register":                 return <LienRegister />;
    case "nominee-register":              return <NomineeRegister />;

    // Generic fallback
    default:
      return <GenericPage pageId={activeMenu} pageLabel={activeMenu} />;
  }
}

// ── Main ─────────────────────────────────────────────────────
export default function AdminApp({ adminUser, onLogout }) {
  const [activeMenu, setActiveMenu] = useState("home");
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div style={{ fontFamily:"'Segoe UI', system-ui, sans-serif", minHeight:"100vh", background:"#f0f2f8" }}>
      <Sidebar activeMenu={activeMenu} setActiveMenu={setActiveMenu} collapsed={sidebarCollapsed} setCollapsed={setSidebarCollapsed} />
      <Topbar onLogout={onLogout} sidebarCollapsed={sidebarCollapsed} adminUser={adminUser} />
      <main style={{ marginLeft: sidebarCollapsed ? 58 : 245, marginTop:54, padding:24, minHeight:"calc(100vh - 54px)", transition:"margin-left 0.25s ease" }}>
        {renderContent(activeMenu, setActiveMenu, adminUser)}
      </main>
    </div>
  );
}
